export const getSlugType = (slug: string): string => {
  try {
    return slug.slice(-8, -6);
  } catch (e) {
    throw new Error('Slug bad format');
  }
};
